import { useState, useEffect } from "react";
import { TableData } from "../components/Table/DataTable";

const usePaginate = () => {
    const [ items, setItems ] = useState<TableData[]>([]);
    const [ itemsPerPage, setItemsPerPage ] = useState(10);
    const [ paginatedItems, setPaginatedItems ] = useState<TableData[]>([]);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ startIndex, setStartIndex ] = useState(0);
    const [ endIndex, setEndIndex ] = useState(0);
    const [ totalPages, setTotalPages ] = useState(0);

    const paginate = (pageNumber: number, itmsPerPage?: number) => {
        let perPage: number = itemsPerPage;

        if (itmsPerPage !== undefined) {
            perPage = itmsPerPage;
        }
        const lastIndex = pageNumber * perPage;
        const firstIndex = lastIndex - perPage;

        setPaginatedItems(items.slice(firstIndex, lastIndex));
        setEndIndex(lastIndex);
        setStartIndex(firstIndex);

        setCurrentPage(pageNumber);
    }

    useEffect(() => {
        const calculatedTotalPages = Math.ceil(items.length/itemsPerPage);
        if (calculatedTotalPages !== totalPages) {
            setTotalPages(calculatedTotalPages);
        }
    }, [items, itemsPerPage, totalPages]);

    useEffect(() => {
        if (items.length > 0) {
            paginate(1);
        }

        //eslint-disable-next-line
    }, [items]);

    return {
        setItems,
        setItemsPerPage,
        setCurrentPage,
        currentPage,
        paginatedItems,
        startIndex,
        endIndex,
        totalPages,
        paginate,
        
    }

} 

export default usePaginate;